// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603120518/js/" + chunkId + "." + {"44":"425f418a","225":"c67e7969","481":"b7b0d93b","486":"d6611039","770":"1c1334a3"}[chunkId] + ".0.17206245507871665.chunk.js";
};